import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { MuiThemeProvider, makeStyles } from '@material-ui/core/styles'
import { VisitsTable } from '../../../components/Tables/VisitsTable'
import { table } from '../../../services/theme'
import {
	getVisitsByHouseholdId,
	clearHouseholdFilters,
	getTrainingEnrollmentsByHouseholdIdAsync
} from '../../../actions/visits/visits.actions'
import { HouseholdVisitsToolbar } from '../../../components/Tables/Toolbars/Household/HouseholdVisitsToolbar'
import useSelectedHousehold from '../../../hooks/useSelectedHousehold'

const useStyles = makeStyles(() => ({
	root: {
		flexGrow: 1
	},
	visitsTableContainer: {
		paddingBottom: 60
	}
}))

const Schedule = () => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const { household, householdVisits, filteredHouseholdVisits } = useSelectedHousehold()
	const toolbarRef = useRef(null)
	const tableRef = useRef(null)

	useEffect(() => {
		dispatch(clearHouseholdFilters())
		dispatch({ type: 'CLEAR_VISITS' })
	}, [])

	useEffect(() => {
		if (household) {
			dispatch(getVisitsByHouseholdId(household._id))
		}
	}, [household?._id])

	useEffect(() => {
		const getEnrollments = async () => {
			if (household && household._id) {
				await getTrainingEnrollmentsByHouseholdIdAsync(dispatch, household._id)
			}
		}

		getEnrollments()
	}, [dispatch, household?._id])

	return (
		<MuiThemeProvider theme={table}>
			<HouseholdVisitsToolbar ref={toolbarRef} tableRef={tableRef} />
			<div className={classes.visitsTableContainer}>
				<VisitsTable tableRef={tableRef} visits={filteredHouseholdVisits} />
			</div>
		</MuiThemeProvider>
	)
}

export default Schedule
